import type { Address, MenuCategory, MenuItem } from "./types";

export const REFERENCE_NOW = "2026-07-31T19:15:00+07:00";
export const categories: MenuCategory[] = ["Mì nước", "Mì trộn", "Món thêm", "Nước"];

const noodleModifiers = [
  {
    id: "noodle",
    label: "Chọn sợi",
    required: true,
    options: [
      { id: "rice", label: "Sợi gạo mềm", price: 0 },
      { id: "egg", label: "Mì trứng dai", price: 8_000 }
    ]
  },
  {
    id: "spice",
    label: "Mức cay",
    required: true,
    options: [
      { id: "none", label: "Không cay", price: 0 },
      { id: "medium", label: "Cay vừa", price: 0 },
      { id: "hot", label: "Cay Bảy", price: 0 }
    ]
  },
  {
    id: "topping",
    label: "Thêm topping",
    required: false,
    options: [
      { id: "none", label: "Không thêm", price: 0 },
      { id: "egg", label: "Trứng lòng đào", price: 16_000 },
      { id: "meat", label: "Thêm thịt", price: 32_000 }
    ]
  }
];

export const menuItems: MenuItem[] = [
  {
    id: "mi-quang",
    category: "Mì nước",
    name: "Mì Quảng gà nướng",
    description: "Sợi nghệ, gà nướng, rau sống, đậu phộng và bánh tráng mè.",
    price: 89_000,
    available: true,
    image: "media/mi-quang.webp",
    allergens: ["Đậu phộng"],
    modifierGroups: noodleModifiers,
    stamp: "MÓN NHÀ"
  },
  {
    id: "hu-tieu",
    category: "Mì nước",
    name: "Hủ tiếu Bảy",
    description: "Nước trong, xá xíu, tôm, hẹ và hành phi.",
    price: 94_000,
    available: true,
    image: "media/hu-tieu.webp",
    allergens: ["Hải sản"],
    modifierGroups: noodleModifiers,
    stamp: "BÁN CHẠY"
  },
  {
    id: "bun-bo",
    category: "Mì nước",
    name: "Bún bò bắp rim",
    description: "Nước dùng sả, bắp bò rim, chả cua và rau răm.",
    price: 105_000,
    available: true,
    allergens: ["Hải sản"],
    modifierGroups: noodleModifiers
  },
  {
    id: "mi-tron",
    category: "Mì trộn",
    name: "Mì trộn cá nục",
    description: "Cá nục kho, rau thơm, đồ chua và dầu hành.",
    price: 88_000,
    available: true,
    image: "media/mi-tron.webp",
    allergens: [],
    modifierGroups: noodleModifiers,
    stamp: "BẾP TỐI"
  },
  {
    id: "banh-canh",
    category: "Mì nước",
    name: "Bánh canh cua rang",
    description: "Sợi bột gạo, cua rang, nấm rơm và hành lá.",
    price: 109_000,
    available: false,
    allergens: ["Hải sản"],
    modifierGroups: noodleModifiers,
    stamp: "HẾT HÔM NAY"
  },
  {
    id: "hoanh-thanh",
    category: "Món thêm",
    name: "Hoành thánh chiên",
    description: "Sáu miếng nhân nấm thịt, chấm sốt mơ ớt.",
    price: 42_000,
    available: true,
    allergens: [],
    modifierGroups: []
  },
  {
    id: "nuoc-sam",
    category: "Nước",
    name: "Nước sâm hạt chia",
    description: "La hán quả, mía lau, hạt chia; ít ngọt.",
    price: 28_000,
    available: true,
    allergens: [],
    modifierGroups: []
  }
];

export const addresses: Address[] = [
  {
    id: "tran-quoc-toan",
    label: "Nhà",
    detail: "18 Trần Quốc Toản, Quận 3",
    distance: 2.8
  },
  {
    id: "nguyen-dinh-chieu",
    label: "Văn phòng",
    detail: "214 Nguyễn Đình Chiểu, Quận 3",
    distance: 1.6
  },
  {
    id: "nguyen-van-linh",
    label: "Ngoài vùng",
    detail: "68 Nguyễn Văn Linh, Quận 7",
    distance: 6.4
  }
];

export const statusLabels = {
  table: ["Đã nhận", "Đang nấu", "Sẵn sàng", "Đã lên bàn"],
  delivery: ["Đã nhận", "Đang nấu", "Sẵn sàng", "Đang giao", "Đã giao"]
} as const;
